import { Component } from '@poa/core';
import { action, observable } from '@poa/state';
import React from 'react';
import ReactDOM from 'react-dom';
import PayerPageTabs from './components/payer-page-tabs';
import { env } from '../../env';



const modalEl = document.getElementById('modal');

export class PayerModal extends React.Component {
  static defaultProps = {
    isOpened: true,
    payerId: -1
  };

  render() {
    const { isOpened, ...rest } = this.props;

    if (isOpened) {
      return ReactDOM.createPortal(<AddPayerModal {...rest} />, modalEl);
    }

    return null;
  }
}


const AddPayerModal = Component()(

  class Modal extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa

    getOriginalModel() {
      return {
          payer_id: null,
          name: null,
          description: null,
          profession: null,
          city: null,
          favorite_places: null,
          living_place: null,
          hobby: null,
          subject_positive: null,
          subject_negative: null,
          subject_triggers: null,
          friends: null,
          children: null,
          parents: null,
          wife: null,
          animals: null,
          gift: false,
          gift_time: null,
          gift_subject: null,
          gift_type: null,
          gift_amount: null,
        }
      }

    async componentDidMount() {
      try {
        const model = await env.http.get(`payer/${this.props.payerId}/`).then(response => response.data);
        this.localState.originalModel = JSON.parse(JSON.stringify(model));
        this.localState.model = model;
        this.localState.loading = false;
        document.body.classList.add('no-scroll');
      } catch (e) {
        console.error(e);
        this.onClose();
      }
    }

    componentWillUnmount() {
      document.body.classList.remove('no-scroll');
    }

    handleOutsideClick = e => {
      if (this.node && this.node.contains(e.target)) {
        return;
      }
      this.onClose();
    };

    localState = observable({
      loading: true,
      isEditMode: true,
      model: null,
      originalModel: null,

      setAdding: () => {
        this.localState.model = observable(
          Object.assign(this.getOriginalModel(), this.localState.model.labels)
        );
      },

      getProps: () => this.props,

    });

    onClose = action(() => {
      this.props.requestClose();
    });

    handleClose = () => {
      this.onClose();
    };

    render() {
      if (this.localState.loading) {
        return (
          <div
            id='account-popup'
            className='popup is-open'
            style={{ display: 'block' }}
          />);
      }

      return (
        <div
          id='account-popup'
          className='popup is-open'
          style={{ display: 'block' }}
          onClick={this.handleOutsideClick}
        >
          <div className='popup__inner' ref={node => (this.node = node)}>
            <PayerPageTabs state={this.localState} onClose={this.handleClose}/>
          </div>
        </div>
      );
    }

  }
);